export default __webpack_public_path__ + "static/demand360-lite-product-8ee677e21ebd3b38979626e20da9b7d6.png";